const actionTypeIdentifier = '883368F1-8FE7-43B5-B3E7-9GC88149D7E5'

export const getOutputComments = `GET-OUTPUT-COMMENTS-${actionTypeIdentifier}`;
export const setOutputError = `SET-OUTPUT-COMMENT-ERROR-${actionTypeIdentifier}`;
export const insertOutputComments = `INSERT-OUTPUT-COMMENTS-${actionTypeIdentifier}`;
export const resetOutputComments = `RESET-OUTPUT-COMMENTS-${actionTypeIdentifier}`;